import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { keyBy } from 'lodash';
import { map } from 'rxjs';
import { ItemService } from '../../services/item.service';
import { ReadOnlyTextCellComponent } from '../read-only-cells/read-only-text-cell/read-only-text-cell.component';

@Component({
  selector: 'h3-read-only-table',
  templateUrl: './read-only-table.component.html',
  styleUrl: './read-only-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReadOnlyTextCellComponent],
})
export class ReadOnlyTableComponent {
  private readonly itemService = inject(ItemService);

  protected items$ = this.itemService.getItems$();
  protected columnCount$ = this.getColumnCount();
  protected contextNames$ = this.getContextNames();
  protected contextsByName$ = this.getContextsByName();

  protected getContextNames() {
    return this.itemService.getItems$().pipe(
      map((items) =>
        items
          .flatMap((item) =>
            this.itemService.getContextStoresForItem(item.index),
          )
          .map((contextStore) => contextStore.state().tags.name),
      ),
      map((tags) => [...new Set(tags)]),
    );
  }

  protected getContextsByName() {
    return this.itemService.getItems$().pipe(
      map((items) =>
        items.map((item) =>
          this.itemService
            .getContextStoresForItem(item.index)
            .map((contextStore) => contextStore.state()),
        ),
      ),
      map((contextsByItem) =>
        contextsByItem.map((contextByItem) =>
          keyBy(contextByItem, (contextStore) => contextStore.tags.name),
        ),
      ),
    );
  }

  protected getColumnCount() {
    return this.itemService.getItems$().pipe(map((items) => items.length));
  }
}
